export default __webpack_public_path__ + "img/3b0d154c0a85f39842c63835251a2dcf.svg";